const state = {
  showLogin: false,
  // identification
  isActivated: false,
  clientID: 0,
  touchScreen: false,
  accessible: false,
  noTouch: false,
  appInitialized: false,
  categoriesURLQueries: undefined,
  styleID: "",
  isAuth: false,
  showCMS: true,
  organizationName: "",
  // indicates whether the user has the site-admin role or not
  isAdmin: false,
  // indicates whether a user is a Rocket employee or not
  isInternal: false,
  // indicates whether the user has signed terms and conditions
  hasSignedAgreements: false,
  siteIds: [],
  userEmail: "",
  // indicates if the async beforeRouteEnter hook is unresolved
  // i.e. if a new page is loading
  isRoutePending: false,
  isMobileDrawerOpen: false,
  // data handling objects
  isSaving: false,
  serverErrorMessage: {}, // used to display a 500 error page
  defaultSiteId: null,
  homeButtonVariant: null,
  selectedHomeButton: null,
  searchQuery: "",
  searchResults: [],
  SiteBuilderForm: {
    siteBuilderForm: {},
    steps: ["Selection", "Confirmation"],
    automaticPopup: false, // whether the site builder form should automatically open when the user visits /categories
  },
  isSiteBuilderFormOpen: false,
  isAnnouncementsEditorOpen: false,
  csDetails: {
    csAlert: false,
    siteOwner: "",
    installationMedia: [],
    notes: "",
    showcaseRating: "",
  },
  SiteNavigator: {
    openOnInit: false,
    openIDs: [],
  },
  Settings: {
    loading: false,
    users: undefined,
    selectedUserIndex: 0,
    error: undefined,
    styling: {
      text: {
        font: "",
        font2: "",
        font3: "",
        customFonts: [],
        metaTitle: "",
        metaDescription: "",
        metaAuthor: "",
        returnHomeTimeout: "360000",
        castEmergencyAnnouncementText: "",
        castEmergencyAnnouncementTheme: "critical",
      },
      color: {
        darkMode: false,
        primaryColor: "rgba(21, 44, 83, 1)",
        primaryColorDark: "rgba(0, 0, 0, 1)",
        primaryColorLight: "rgba(150, 150, 150, 1)",
        enableCustomColors: true,

        // global custom color values
        backgroundColor: "",
        bannerBodyBackgroundColor: "",
        bannerBodyTextColor: "",
        bannerHeaderBackgroundColor: "",
        bannerStripeColor: "",
        bannerTitleColor: "",
        categoryLogoCardBackground: "",
        categoryLogoCardHeaderColor: "",
        categoryLogoCardStripe: "",
        categoryLogoCardText: "",
        categoryTextColor: "",
        headerStripeColor: "",
        homeButtonsColor: "",
        personStripeTextColor: "",
        startColor: "",
        titleColor: "",
        pillCategoryTextColor: "",
      },
      toggle: {
        castEmergencyAnnouncementEnabled: "",
        editSuggestionEnabled: "",
        isMassivePortraitScreen: "",
      },
    },
  },
  Home: {
    styling: {
      text: {
        title: "",
        startButtonText: "",
        homeDescription: "",
        homeDescriptionFontSize: "",
        defaultDescription: "",
        calendarLink: "",
        font: "",
        font2: "",
        font3: "",
        sponsorText: "",
      },
      toggle: {
        homeGradient: "",
        homeBlur: "",
      },
      pageSettingsToggle: {
        showLogo: "",
        showTitle: "",
      },
      photo: {
        backgroundImage: [],
        primaryLogo: [],
        sponsorImages: [],
        presentingSponsorImages: [],
      },
      media: {
        media: [],
      },
      dropdown: {
        sponsorStyle: "",
        carouselCategory: "",
        carouselCategoryIds: [],
        gridCategoryId: "",
      },
      homeButtons: {
        homeButtons: [],
      },
      socialMedia: {
        socialMediaInfo: "",
      },
      animation: {
        backgroundSlideshowKenBurns: false,
        sparkleAnimation: false,
      },
      announcements: {
        announcements: [],
      },
      header: {
        headerType: "",
      },
    },
    page: {
      layout: {
        layout: "",
      },
      animation: {
        confettiAnimation: false,
      },
    },
  },
  Categories: {
    styling: {
      nonCMS: {
        categoryBrightness: "",
        mixBlendMode: "",
      },
      toggle: {
        categoriesGradient: "",
      },
      pageSettingsToggle: {
        siteNavigationDefaultOpen: false,
        showFooterQR: false,
      },
    },
    page: {
      layout: {
        categoriesLayout: "",
      },
      animation: {
        confettiAnimation: false,
      },
      siteBuilderForm: {
        siteBuilderFormComplete: false,
      },
      toggle: {
        hideFolderCardNames: false,
      },
    },
  },
  SubCategories: {
    styling: {
      nonCMS: {
        categoryBrightness: "",
        mixBlendMode: "",
      },
    },
    page: {
      layout: {
        subcategoryLayout: "",
      },
      text: {
        categoryName: "",
        categoryDescription: "",
      },
      photo: {
        background: "",
        cardBackground: "",
      },
      nonCMS: {
        parentCategoryID: "",
      },
      animation: {
        confettiAnimation: false,
      },
      toggle: {
        hideFolderCardNames: false,
      },
    },
  },
  Category: {
    styling: {
      photo: {
        genericImage: [],
      },
      nonCMS: {
        personStripeBrightness: "",
      },
      toggle: {
        categoryGradient: "",
      },
    },
    page: {
      text: {
        categoryName: "",
        eventDateAlternativeName: "",
        graduationDateAlternativeName: "",
        activityAlternativeName: "",
        typeAlternativeName: "",
        slideshowImage1AlternativeName: "",
        slideshowVideoAlternativeName: "",
        categoryDescription: "",
      },
      photo: {
        background: [],
        cardBackground: [],
        defaultPersonCardBackground: [],
      },
      dropdown: {
        orderingAttribute: "",
        dateFormat: "",
      },
      multiSelect: {
        attributesCategories: {},
      },
      layout: {
        layout: "",
        defaultEntryLayout: "",
      },
      toggle: {
        // isLive: "",
        sortDescending: "",
        showNavigationButtons: "",
        hideFolderCardNames: "",
      },
      nonCMS: {
        parentCategoryID: "",
      },
      recordColumns: {
        recordColumns: "",
      },
      filters: {
        filterCategories: {},
      },
      animation: {
        confettiAnimation: false,
      },
    },
  },
  Person: {
    styling: {
      toggle: {
        entryGradient: "",
      },
    },
    page: {
      text: {
        firstName: "",
        lastName: "",
        activity: "",
        type: "",
        description: "",
        iframeLayoutURL: "",
        iframeSheetName: "",
      },
      toggle: {
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
      },
      tableOfContents: {
        tableOfContents: [],
      },
      date: {
        eventDate: "",
        graduationDate: "",
      },
      photo: {
        headshot: [],
        background: [],
        cardBackground: [],
      },
      layout: {
        layout: "",
      },
      nonCMS: {
        categoryID: "",
      },
      media: {
        media: [],
      },
      animation: {
        confettiAnimation: false,
      },
    },
  },
};

export default state;
